<mat-card class="m-b-15 flow-file-uploader-cntr">
  <mat-card-header>
    <div mat-card-avatar class="d-flex">
      <mat-icon class="m-auto" color="primary">
        {{ configuration.icon }}</mat-icon
      >
    </div>
    <mat-card-title class="header-flow-file">

      {{ configuration.title }}

      <button
        *ngIf="showInfoButton()"
        color="primary"
        mat-icon-button
        matSuffix
        (click)="openInfoDialog()">

        <mat-icon style="font-size: 25px; font-weight: bold">info_outline</mat-icon>

      </button>

    </mat-card-title>
    <mat-card-subtitle
      ><p [innerHtml]="configuration.description"></p
    ></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <ct-file-uploader
      #Uploader
      [configuration]="configuration.ctFileUploaderConfiguration"
      (delete)="deleteFile($event)"
    ></ct-file-uploader>
  </mat-card-content>
</mat-card>
